module.exports = __webpack_public_path__ + "img/event-2023-09-29-studio-carre.9ed7e11.jpg";